(function () {
    'use strict';

    angular.module('swif.interventions')
    .config(route)
    .factory('TasksStatisticsService', TasksStatisticsService)
    .controller('TasksStatisticsController', TasksStatisticsController);

    function route ($routeProvider, swifInterventionsConstant) {
        'ngInject';
        $routeProvider.when(swifInterventionsConstant.task.routes.statistics_view, {
            templateUrl: 'partials/openstc/tasks_statistics_view.html',
            controller: 'TasksStatisticsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check({resources: ['d3']});
                }]
            }
        });
    }

    function TasksStatisticsService ($q, swif, gettextCatalog, swifDownloadService) {
        'ngInject';
        var download = swifDownloadService;
        /*
         * definition of available 'what' values:
         * - id: the field to use on the statistics records object,
         * - label: a string describing the data (translated and displayed on UI),
         * - defaultVal: (any type) default value to be set if the server returns no value for this field
         * - type: optional type, allowing special treatment of the data, such as count of tasks (TODO):
         *     * 'hour': apply the 'h' suffix to the hour, considered as a time value (hours + minutes)
         *     * 'currency': apply the localized currency, default to euro currency (displayed as currency precision)
        */
        var service = {
            whats: {
                nb_ask: {id: 'nb_ask', label: 'Number Asks', defaultVal: 0.0},
                nb_inter: {id: 'nb_inter', label: 'Number Interventions', defaultVal: 0.0},
                nb_task: {id: 'nb_task', label: 'Nb Tasks', defaultVal: 0.0},
                hours: {id: 'effective_hours', label: 'Effective hours', defaultVal: 0.0, type: 'hour'},
                cost: {id: 'task_cost', label: 'Total costs', defaultVal: 0.0, type: 'currency'},
                hr_cost: {id: 'hr_cost', label: 'HR costs', defaultVal: 0.0, type: 'currency'},
                equipment_cost: {id: 'task_equipment_cost', label: 'Equipments costs', defaultVal: 0.0, type: 'currency'},
                consumable_cost: {id: 'task_consumable_cost', label: 'Consumables costs', defaultVal: 0.0, type: 'currency'},

            },
            exportCsv: exportCsv,
            _getDefaultVal: _getDefaultVal,
            groupBy: groupByFct
        };
        return service;

        function exportCsv (by, by2, domain, what, start, end, type) {
            var groupBy = [by];
            if(by2){
                groupBy.push(by2);
            }

            var view = 'statistics_task'

            if (type === 'nb_ask') {
                view = 'statistics_ask'
                domain = domain.filter(x => !x.includes("effective_hours"))
            }

            if (type === 'nb_inter') {
                view = 'statistics_inter'
                domain = domain.filter(x => !x.includes("effective_hours"))
            }

            if (type === 'nb_task') {
                view = 'statistics_nbtask'
                domain = domain.filter(x => !x.includes("effective_hours"))
            }

            download.params = swif.data._computeSaveAsPOST(
                view,
                'csv_data',
                false,
                'csv_data_filename',
                {
                    settings: {
                        what: what,
                        group_by: groupBy,
                        domain: domain,
                        date_start: start,
                        date_end: end
                    }
                }
            );
        }

        function _getDefaultVal (item, field, defaultVal) {
            var ret = defaultVal || '';
            if(_.isArray(item[field]) && item[field].length === 2) {
                ret = item[field][1];
            }

            if(item.__is_date) {
                // Try to parse date depending on server locale
                var month = item[field];

                // Load Fr translation
                moment.locale('fr');

                // Warning: MomentJs will invalid the date if the server locale data mismatch the locale language
                var frDate = moment(month, 'MMM YYYY', 'fr'); // Could be invalid if the month is in En
                var enDate = moment(month, 'MMM YYYY', 'en'); // Could be invalid if the month is in Fr

                if(enDate.isValid()) {
                    // Convert to French month
                    month = enDate.locale('fr').format('MMM YYYY');
                    // We need to use moment again, enDate might be invalid
                    ret = moment(month, "MMM YYYY").toDate();
                } else {
                    if(frDate.isValid()) {
                        ret = moment(month, "MMM YYYY").toDate();
                    } else {
                        console.log('Invalid Server locale');
                    }
                }
            }

            return ret;
        }

        /* python-like method '{}.fromkeys()}',
         * compute object with default values for given keys
         @param keys: (Array of string) to be used as object attributes
         @param defaultVal: (any type) value to be set for each key (the value is cloned for each key)
         */
        function _objectFromKeys (keys, defaultVal) {
            var ret = {};
            _.forEach(keys, function (key) {
                ret[key] = angular.copy(defaultVal);
            });
            return ret;
        }

        function groupByFct (by, by2, domain, type) {
            var whatsKeys = _.pluck(service.whats, 'id');
            var fields = angular.copy(whatsKeys);
            fields.push(by);
            var groupBy = [by];
            if(by2) {
                fields.push(by2);
                groupBy.push(by2);
            }
            var data = _objectFromKeys(whatsKeys, []);
            var rawData = _objectFromKeys(whatsKeys, {});

            var ret = $q.defer();

            // TG 3206 - calculted number for team may be wrong,
            // therefore a flag is set to know if stat display team
            var team_id = false;
            for (var cpt = 0; cpt < domain.length; cpt++){
                if(domain[cpt].length > 0 && domain[cpt][0] == 'team_id'){
                    team_id = true;
                }
            }

            var view = 'statistics_task'

            if (type === 'nb_ask') {
                view = 'statistics_ask'
                domain = domain.filter(x => !x.includes("effective_hours"))
                fields = ["nb_ask","date_start"]
                groupBy = groupBy.map(x => x.replace("equipement_inter", "equipement_ask"))
            }

            if (type === 'nb_inter') {
                view = 'statistics_inter'
                domain = domain.filter(x => !x.includes("effective_hours"))
                fields = ["nb_inter","date_start"]
            }

            if (type === 'nb_task') {
                view = 'statistics_nbtask'
                domain = domain.filter(x => !x.includes("effective_hours"))
                fields = ["nb_task","date_start"]
            }

            swif.data.callKw(
                view,
                'group_by',
                [domain, fields, groupBy]
            ).then(function (values) {
                _.forEach(values, function (item) {
                    var miscLabel = gettextCatalog.getString('Misc');
                    var defaultX = service._getDefaultVal(item, by, miscLabel);
                    /* data.hours.push([defaultX, item.effective_hours]);
                    data.costs.push([defaultX, item.hr_cost || 0.0]); */
                    _.forEach(service.whats, function (what) {
                        if (data[what.id]) {
                            data[what.id].push([defaultX, item[what.id] || what.defaultVal]);
                        }
                    });
                    if(by2) {
                        if(item.__values) {
                            /* rawData.hours[defaultX] = [];
                            rawData.costs[defaultX] = []; */
                            // for each rawData, prepare value for current x
                            _.forEach(rawData, function (raw) {
                                raw[defaultX] = [];
                            });
                            // then, browse the values to populate the current x on each raw-data
                            _.forEach(item.__values, function (value) {
                                var defaultX2 = service._getDefaultVal(value, by2);
                                _.forEach(service.whats, function (what) {
                                    if (rawData[what.id]) {
                                        /* rawData.hours[defaultX].push([defaultX2, value.effective_hours]);
                                        rawData.costs[defaultX].push([defaultX2, value.hr_cost || 0.0]); */
                                        rawData[what.id][defaultX].push([defaultX2, value[what.id] || what.defaultVal]);
                                    }
                                });

                            });
                        } else {
                            console.error('Err: group_by() method does not return __values key');
                        }
                    }
                });
                var val = {data: data};
                if(by2) {
                    val.rawData = rawData;
                }
                ret.resolve(val);
            });
            return ret.promise;
        }
    }

    function TasksStatisticsController($scope, $q, swif, TasksStatisticsService, gettextCatalog, data, swifStatisticsService, swifOpenbaseCompanyService) {
        'ngInject';

        swif.settings.page.title = 'Statistics';

        // ********* state *************
        $scope.data = data;

        /* (re)initialize each filter of the "settings" form  and some settings */

        $scope.stateValues = swif.settings.app.contentTypes['intervention'].filterSettings.find(x => x.field === 'state').vocabulary;
        $scope.years = swifStatisticsService.getYears();
        $scope.displayFilter = true;
        $scope.patrimoineOperatorChildOf = true;
        $scope.searchFilter = {
            patrimoineType: 'site',
            actorType: 'user',
            categoryType: 'task_category',
            claimerType: 'claimer',
            periodType: 'manual',
            start_period: swifStatisticsService.getDefaultStartPeriod(),
            end_period: swifStatisticsService.getDefaultEndPeriod(),
            vocabulariesFilters: {patrimoines: {}, actors: {}, categories: {}, claimers: {}, state: {}}
        };

        $scope.whatsDefinition = TasksStatisticsService.whats;
        $scope.chartsSettings = {
            what: 'hours',
            groupBy: 'user'
        };
        $scope._data = {};

        $scope.view = 'task'

        // ********* functions *************
        $scope.exportCsv = exportCsv;
        $scope.fetchChartsData = fetchChartsData;
        $scope._computeChartsFilter = _computeChartsFilter;

        $scope.populateCharts = populateCharts;
        $scope.populateTable = populateTable;
        $scope.populateStateFilter = populateStateFilter;
        $scope.populateLineChart = populateLineChart;
        $scope.populatePieCharts = populatePieCharts;

        $scope.getSelectedWhat = getSelectedWhat;
        $scope.updatePatrimoineFilters = updatePatrimoineFilters;
        $scope.updateActorUniqueidsFilters = updateActorUniqueidsFilters;
        $scope.updateActorSpecificFilters = updateActorSpecificFilters;
        $scope.updateCategoryFilters = updateCategoryFilters;
        $scope.updateClaimerSpecificFilters = updateClaimerSpecificFilters;
        $scope.updateClaimerFilters = updateClaimerFilters;

        $scope.getXSum = getXSum;
        $scope.getYSum = getYSum;

        $scope.$watch('searchFilter.patrimoines', watchSearchFilterPatrimoines);
        $scope.$watch('patrimoineOperatorChildOf', watchPatrimoineOperatorChildOf);
        $scope.$watch('searchFilter.patrimoineType', watchSearchFilterPatrimoineType);
        $scope.$watch('searchFilter.actors', watchSearchFilterActors);
        $scope.$watch('searchFilter.actorType', watchSearchFilterActorType);
        $scope.$watch('searchFilter.categories', watchSearchFilterCategories);
        $scope.$watch('searchFilter.categoryType', watchSearchFilterCategoryType);
        $scope.$watch('searchFilter.claimers', watchSearchFilterClaimers);
        $scope.$watch('searchFilter.claimerType', watchSearchFilterClaimerType);
        $scope.$watch('searchFilter.state', watchSearchFilterState);
        $scope.$watch('chartsSettings.what', watchChatsSettings);
        $scope.$watchGroup([
            'searchFilter.start_period',
            'searchFilter.end_period',
            'chartsSettings.groupBy'
        ], whatchGroupFilters);

        var MAP_FIELDS = {
            site: 'site1',
            equipment_category: 'equipment_category_id',
            equipment: 'equipment_inter',
            site_category: 'site_type_id',
            user: 'user_id',
            team: 'team_id',
            department: 'service_id',
            partner: 'partner_id',
            task_category: 'category_id',
            intervention_category: 'intervention_assignement_id',
            claimer: 'claimer_id',
            claimer_type: 'claimer_type'
        };

        $scope.fetchChartsData();

        swifOpenbaseCompanyService.getCurrencySymbol().then(function(symbol){

            $scope.linePlusBarChartOptions = {
                chart: {
                    type: 'linePlusBarChart',
                    height: 400,
                    margin: {
                        top: 30,
                        right: 75,
                        bottom: 50,
                        left: 75
                    },
                    focusEnable:false,
                    bars: {
                        forceY: [0]
                    },
                    color: ['#2ca02c', 'darkred'],
                    x: function(d,i) { return i },
                    xAxis: {
                        tickFormat: function(d) {
                            var dx = $scope.linePlusBarChartData[0].values[d] && $scope.linePlusBarChartData[0].values[d].x || 0;
                            if (dx > 0) {
                                return d3.time.format('%m/%Y')(new Date(dx))
                            }
                            return null;
                        }
                    },
                    y1Axis: {
                        tickFormat: function(d){
                            var y1legend = d3.format(',f')(d).replace(',',' ')
                            if (['nb_inter', 'nb_ask', 'nb_task'].includes($scope.chartsSettings.what)) {
                                return y1legend
                            }
                            return y1legend + 'h';
                        }
                    },
                    y2Axis: {
                        tickFormat: function(d) {
                            var y2legend = d3.format(',f')(d).replace(',',' ')
                            if (['nb_inter', 'nb_ask', 'nb_task'].includes($scope.chartsSettings.what)) {
                                return y2legend
                            }
                            return y2legend + symbol;
                        }
                    },
                    tooltip: {
                        contentGenerator: function (e) {
                            if (_.isUndefined(e.data)) return;
                            var dx = e.data.x;
                            if (dx > 0) {
                                dx = d3.time.format('%m/%Y')(new Date(dx))
                            }

                            var ytest = d3.format(',f')(e.data.y).replace(',',' ');
                            if (!['nb_inter', 'nb_ask', 'nb_task'].includes($scope.chartsSettings.what)) {
                                ytest = ytest + 'h'
                            }
                            return "<p>" +  ytest + " le " + dx + "</p>";
                        }
                    }
                }
            };

            $scope.pieChartOptions = {
                chart: {
                    type: 'pieChart',
                    height: 400,
                    x: function(d){return d.key;},
                    y: function(d){return d.y;},
                    showLabels: true,
                    duration: 500,
                    labelThreshold: 0.01,
                    labelSunbeamLayout: true,
                    legendPosition: 'right',
                    tooltip: {
                        contentGenerator: function (e) {
                            var series = e.series[0];
                            if (series.value === null) return;
                            var typeToSuffix = {currency: symbol, hours: 'h'};

                            return "<h4>" + series.key + "</h4>" +
                                "<p>" +  series.value + (typeToSuffix[$scope.getSelectedWhat().type] || '')+ "</p>";
                        }
                    }
                }
            };

        });

        function getSelectedWhat () {
            return $scope.whatsDefinition[$scope.chartsSettings.what || 'hours'];
        }

        function _compute_end_date() {
            let endDate = new Date($scope.searchFilter.end_period);
            let end = new Date(endDate.setDate(endDate.getDate() + 1))

            return moment(new Date(endDate.getTime() +75600000)).format("YYYY-MM-DD");

        }

        /* compute the collection filter according to the settings on the form */
        function _computeChartsFilter () {

            var STATE_FIELDS = {nb_inter:'state_inter',nb_task:'state_task', nb_ask:'state_ask'};

            var patrimoineField = MAP_FIELDS[$scope.searchFilter.patrimoineType];
            var actorField = MAP_FIELDS[$scope.searchFilter.actorType];
            var categoryField = MAP_FIELDS[$scope.searchFilter.categoryType];
            var claimerField = MAP_FIELDS[$scope.searchFilter.claimerType];
            var stateField = STATE_FIELDS[$scope.chartsSettings.what]

            var _prepareFilters = function (filter, name, field, data, addField, childOf) {
                var operator = 'in';
                if (childOf) {
                    operator = 'child_of';
                }
                if(field && !_.isEmpty(data)) {
                    swif.data.addExtraFilter(filter, name, field, operator, data);
                    if(addField) {
                        filter.fields.push(field);
                    }
                }
            };

            var filter = {};
            let endFormat = _compute_end_date()
            swif.data.addExtraFilter(filter, 'stats', 'effective_hours', '>', 0.0);
            swif.data.addExtraFilter(filter, 'stats', 'date_start', '>=', $scope.searchFilter.start_period);
            swif.data.addExtraFilter(filter, 'stats', 'date_start', '<', endFormat);

            _prepareFilters(filter, 'stats', patrimoineField, $scope.searchFilter.patrimoines, false, $scope.patrimoineOperatorChildOf);
            _prepareFilters(filter, 'stats', actorField, $scope.searchFilter.actors);
            _prepareFilters(filter, 'stats', categoryField, $scope.searchFilter.categories);
            _prepareFilters(filter, 'stats', claimerField, $scope.searchFilter.claimers);
            _prepareFilters(filter, 'stats', stateField, $scope.searchFilter.state);

            return filter;
        }

        function populatePieCharts () {
            var what = $scope.getSelectedWhat();
            var pieChartData = [];
            if ($scope.pieChartCollection[what.id]) {
                _.forEach($scope.pieChartCollection[what.id], function (item) {
                    pieChartData.push({key: item[0], y: item[1]});
                });
                $scope.pieChartData = pieChartData;
            }
        }

        function populateLineChart () {
            var linePlusBarChartData = [];
            var what = $scope.getSelectedWhat();
            var what2 = $scope.whatsDefinition.cost;
            if ($scope.getSelectedWhat().type === 'currency') {
                what2 = $scope.getSelectedWhat();
            }
            linePlusBarChartData.push({
                key: gettextCatalog.getString(what.label),
                values: $scope._data.byDate[what.id],
                bar: true
            });
            linePlusBarChartData.push({
                key: gettextCatalog.getString(what2.label),
                values: $scope._data.byDate[what2.id]
            });
            $scope.linePlusBarChartData = linePlusBarChartData.map(function(series) {
                series.values = series.values.map(function(d) { return {x: d[0], y: d[1] } });
                return series;
            });
        }

        function populateTable () {
            /*
             @param data: (Collection or List) collection being sanitized
             @param dateRange: (List of Date())range of the current period
             @param defaultVal: (Integer or String) optionnal, value for unset dates
            */
            var sanitizeListOfDates = function (data, dateRange, defaultVal) {
                defaultVal = defaultVal || 0.0;
                var ret = [];
                _.forEach(dateRange, function (item) {
                    var elt = _.find(data, function (a) {
                        // a = [Date(), Float]
                        return a[0].getTime() === item.getTime();
                    });
                    if(elt) {
                        ret.push(elt[1]);
                    } else {
                        ret.push(defaultVal);
                    }
                });
                return ret;
            };
            // TODO: Must be check if what.id exists or not in tableChart and _data.byDate data
            var what = $scope.getSelectedWhat();
            var firstset = _.cloneDeep($scope.tableChartCollection[what.id]);
            // then, group each subset of 'tasks' by date
            // to do that, I compute x-axis dates, also used to compute default values
            // as we want a table, all the cells may appear on the dataset
            var xAxis = [];
            var months = moment().range($scope.searchFilter.start_period, $scope.searchFilter.end_period);
            months.by('months', function (monthItem) {
                xAxis.push(moment(monthItem.format('YYYY-MM-01 00:00:00')).toDate());
            });

            var nbTeamMember = Object.keys(firstset).length;
            if (nbTeamMember === 0) {
              nbTeamMember = 1;
            }
            var taskFilters = $scope._computeChartsFilter()
            var domain = taskFilters.filters.stats;
            var teamId = -1;
            _.forEach(domain, function(itDomain) {
              if (itDomain.length >= 1 && itDomain[0] === 'team_id') {
                teamId = itDomain[2][0];
              }
            });

            var ret = [];
            // sanitize data, to have as much dates as the header requires
            _.forEach(firstset, function(itemFirstset, key) {
                // TG 3206 - task consumable cost must be divided by the number of team member
                if (teamId >= 0 && (what.id === 'task_consumable_cost' || what.id === 'task_equipment_cost' || what.id === 'task_cost')) {
                  _.forEach(itemFirstset, function(cptItemFirstset) {
                      cptItemFirstset[1] =  cptItemFirstset[1] / nbTeamMember;
                  });
                }
                ret.push({
                    key: key,
                    values: sanitizeListOfDates(itemFirstset, xAxis)
                });
            });
            var subtotals = $scope._data.byDate[what.id];
            if (teamId >= 0 && what.id === 'task_cost') {
                _.forEach(subtotals, function(itemSubtotals) {
                    itemSubtotals[1] =  itemSubtotals[1] / nbTeamMember;
                })
            }
            ret.push({
                key: 'Total',
                values: sanitizeListOfDates(subtotals, xAxis)
            });

            $scope.tableXAxis = xAxis;
            $scope.tableData = ret;
        }

        /* Compute data from scope.tasks and trigger the display of the charts */
        function populateCharts () {
            $scope.populatePieCharts();
            $scope.populateLineChart();
            $scope.populateTable();
        }

        /* call _compteChartsFilter and then perform the Ajax POST */
        function fetchChartsData () {
            var taskFilters = $scope._computeChartsFilter();
            /* @TODO: When currentFilter has more than one key changed,
                it performs one change PER updatd key...
                change this to only fetch the collection once,
                for example, set a static fields to not trigger the update
            */
            var field = MAP_FIELDS[$scope.chartsSettings.groupBy];
            $q.all([
                TasksStatisticsService.groupBy('date_start', false, taskFilters.filters.stats, $scope.view),
                TasksStatisticsService.groupBy(field, 'date_start', taskFilters.filters.stats, $scope.view)
            ]).then(function (data) {
                // collapse data: grouped values by date only
                // so it has only 1 level or precision
                $scope._data.byDate = data[0].data;
                // expanded data: grouped values by date AND by selected 'what'
                // so it has 2 levels of precision
                $scope._data.byWhatAndDate = data[1];

                $scope.pieChartCollection = $scope._data.byWhatAndDate.data;
                $scope.tableChartCollection = angular.copy($scope._data.byWhatAndDate.rawData);
                $scope.populateCharts();
            });
        }

        function updatePatrimoineFilters () {
            var patrimoine_ids = $scope.searchFilter.patrimoines;

            swif.data.resetExtraFilter($scope.searchFilter.vocabulariesFilters.patrimoines, 'uniqueIds');
            if(patrimoine_ids && !_.isEmpty(patrimoine_ids)) {
                swif.data.addExtraFilter($scope.searchFilter.vocabulariesFilters.patrimoines, 'uniqueIds', 'id', '!=', patrimoine_ids);
            }
        }


        function watchSearchFilterPatrimoines (newV, oldV) {
            if(!angular.equals(newV, oldV)) {
                $scope.updatePatrimoineFilters();
                $scope.fetchChartsData();
            }
        }
        function watchPatrimoineOperatorChildOf (newV, oldV) {
            if(!angular.equals(newV, oldV)) {
                $scope.updatePatrimoineFilters();
                $scope.fetchChartsData();
            }
        }

        function watchSearchFilterPatrimoineType (newV, oldV) {
            if(!angular.equals(newV, oldV)) {
                $scope.searchFilter.patrimoines = [];
            }
            $scope.patrimoineOperatorChildOf = newV === 'site';
        }

        function updateActorUniqueidsFilters () {
            var actor_ids = $scope.searchFilter.actors;

            swif.data.resetExtraFilter($scope.searchFilter.vocabulariesFilters.actors, 'uniqueIds');
            if(actor_ids && !_.isEmpty(actor_ids)) {
                swif.data.addExtraFilter($scope.searchFilter.vocabulariesFilters.actors, 'uniqueIds', 'id', '!=', actor_ids);
            }
        }

        function updateActorSpecificFilters () {
            var filters = [];
            switch($scope.searchFilter.actorType) {
                case 'user':
                    filters = [['service_ids.technical', '=', true]];
                break;
                case 'department':
                    filters = [['technical', '=', true]];
                    break;
                case 'partner':
                    filters = [['supplier', '=', true], ['is_department', '=', false]];
                    break;
            }
            swif.data.resetExtraFilter($scope.searchFilter.vocabulariesFilters.actors, 'technical');
            _.forEach(filters, function (filter) {
                swif.data.addExtraFilter($scope.searchFilter.vocabulariesFilters.actors, 'technical', filter[0], filter[1], filter[2]);
            });
        }

        function watchSearchFilterActors(newV, oldV) {
            if(!angular.equals(newV, oldV)) {
                $scope.updateActorUniqueidsFilters();
                $scope.fetchChartsData();
            }
        }

        function watchSearchFilterActorType (newV, oldV) {
            if(!angular.equals(newV, oldV)) {
                $scope.searchFilter.actors = [];
                $scope.updateActorSpecificFilters();
            }
        }

        function updateCategoryFilters () {
            var category_ids = $scope.searchFilter.categories;

            swif.data.resetExtraFilter($scope.searchFilter.vocabulariesFilters.categories, 'uniqueIds');
            if(category_ids && !_.isEmpty(category_ids)) {
                swif.data.addExtraFilter($scope.searchFilter.vocabulariesFilters.categories, 'uniqueIds', 'id', '!=', category_ids);
            }
        }

        function updateClaimerSpecificFilters () {
            swif.data.resetExtraFilter($scope.searchFilter.vocabulariesFilters.claimers, 'technical');
            if($scope.searchFilter.categoryType === 'claimer') {
                swif.data.addExtraFilter(
                    $scope.searchFilter.vocabulariesFilters.claimers,
                    'claimer',
                    'customer',
                    '=',
                    true
                );
            }
        }

        function watchSearchFilterCategories (newV, oldV) {
            if(!angular.equals(newV, oldV)) {
                $scope.updateCategoryFilters();
                $scope.fetchChartsData();
            }
        }

        function watchSearchFilterCategoryType (newV, oldV) {
            if(!angular.equals(newV, oldV)) {
                $scope.searchFilter.categories = [];
                $scope.updateClaimerSpecificFilters();
            }
        }

        function updateClaimerFilters () {
            var claimer_ids = $scope.searchFilter.claimers;

            swif.data.resetExtraFilter($scope.searchFilter.vocabulariesFilters.claimers, 'uniqueIds');
            if(claimer_ids && !_.isEmpty(claimer_ids)) {
                swif.data.addExtraFilter($scope.searchFilter.vocabulariesFilters.claimers, 'uniqueIds', 'id', '!=', claimer_ids);
            }
        }

        function watchSearchFilterClaimers (newV, oldV) {
            if(!angular.equals(newV, oldV)) {
                $scope.updateClaimerFilters();
                $scope.fetchChartsData();
            }
        }

        function watchSearchFilterClaimerType (newV, oldV) {
            if(!angular.equals(newV, oldV)) {
                $scope.searchFilter.claimers = [];
            }
        }

        function watchSearchFilterState (newV, oldV) {
            if(!angular.equals(newV, oldV)) {
                $scope.fetchChartsData();
            }
        }

        function populateStateFilter (chartsSettings) {
            if (chartsSettings === 'nb_ask') {
                $scope.stateValues = swif.settings.app.contentTypes['intervention_request'].filterSettings.find(x => x.field === 'state').vocabulary;
            }
            if (chartsSettings === 'nb_inter') {
                $scope.stateValues = swif.settings.app.contentTypes['intervention'].filterSettings.find(x => x.field === 'state').vocabulary;
            }
            if (chartsSettings === 'nb_task') {
                $scope.stateValues = swif.settings.app.contentTypes['task'].filterSettings.find(x => x.field === 'state').vocabulary;
            }
        }

        $scope.$watch('searchFilter.periodType', watchSearchFilterPeriodType);
        function watchSearchFilterPeriodType (newV, oldV) {
            if(newV && !angular.equals(newV, oldV)) {
                if(newV !== 'manual') {
                    $scope.searchFilter.start_period = newV + '-01-01';
                    $scope.searchFilter.end_period = newV + '-12-31';
                }
            }
        }

        function whatchGroupFilters (newV, oldV) {
            if(!angular.equals(newV, oldV)) {
                $scope.fetchChartsData();
            }
        }

        function watchChatsSettings (newV, oldV) {
            if(!angular.equals(newV, oldV)) {
                if (!_.isEmpty($scope.searchFilter.state)){
                    $scope.searchFilter.state = []
                }
                if  (['nb_inter', 'nb_ask', 'nb_task'].includes(newV)) {
                    $scope.populateStateFilter(newV);
                    $scope.view = newV
                    $scope.fetchChartsData();
                }else if (['nb_inter', 'nb_ask', 'nb_task'].includes(oldV)) {
                    $scope.view = 'task'
                    $scope.fetchChartsData();
                }

                $scope.populateCharts();
            }
        }

        // @param data: (Array) values of the current row to sum
        function getXSum (data) {
            var ret = 0.0;
            _.forEach(data, function (item) {
                ret += item;
            });
            return ret;
        }

        /* @param data: (Array of Object) values of the whole table to sum
           @param index: the date-position for which we want to group 'data'
               (as each value is sorted by date, having the index is enough)
               if index is 'all', will compute all the cells (for global Total)
           @param typeData (String): used to retrieve the correct dataset
        */
        function getYSum (data, index) {
            var ret = 0.0;
            var wholeRow = index === 'all';
            _.forEach(data, function (item) {
                if(wholeRow) {
                    ret += $scope.getXSum(item.values);
                } else {
                    ret += item.values[index] || 0.0;
                }
            });
            return ret;
        }

        function exportCsv () {
            var field = $scope.getSelectedWhat().id;
            var filter = $scope._computeChartsFilter();
            let  endFormat = _compute_end_date()
            TasksStatisticsService.exportCsv(
                MAP_FIELDS[$scope.chartsSettings.groupBy],
                'date_start',
                filter.filters.stats,
                field,
                $scope.searchFilter.start_period,
                endFormat,
                $scope.view
            );
        }
    }

})();
